import { FormlyFieldConfig } from '@ngx-formly/core';
import { IUpsertLookupRequest } from '../requests';

export class UpsertLookupModel implements IUpsertLookupRequest {
  englishName?: string;
  isActive?: boolean;

  constructor(request: IUpsertLookupRequest) {
    this.englishName = request.englishName;
  }

  static create(data: IUpsertLookupRequest): UpsertLookupModel {
    return new UpsertLookupModel(data);
  }

  static createDefault(): UpsertLookupModel {
    return UpsertLookupModel.create({
      englishName: ''
    });
  }

  getFormlyConfig(): FormlyFieldConfig[] {
    return [
      {
        key: 'englishName',
        type: 'input',
        templateOptions: {
          label: 'Customer Name',
          placeholder: 'Enter customer name',
          required: true
        }
      }
    ];
  }
}
